// extracted by mini-css-extract-plugin
export default {"menu":"PageLayout_menu__l0wLf","appStyleOpen":"PageLayout_appStyleOpen__DyU02","viewport":"PageLayout_viewport__YtbYE","viewportOpen":"PageLayout_viewportOpen__EO354"};